import React, { Component } from 'react';
import { connect } from "react-redux";
import { ResponsiveContainer, XAxis, YAxis, CartesianGrid, BarChart, Bar } from "recharts";


class ArticleBreakdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    
    render() {
        return(
            <div className="card">
                <div className="card-divider">
                    <span className = "card-header-title">Articles</span>
                </div>
                <div className="overlay_block_main">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={this.props.stakeholder.current_overlay_media_breakdown}
                                    margin={{top: 5, right: 5, left: 5, bottom: 5}}>
                            <CartesianGrid strokeDasharray="3 3"/>
                            <XAxis dataKey="name"/>
                            <YAxis allowDecimals={false}/>
                            <Bar dataKey="Negative" stackId="a" fill="#EE4244" />
                            <Bar dataKey="Somewhat Negative" stackId="a" fill="#ED8D5F" />
                            <Bar dataKey="Neutral" stackId="a" fill="#ECDE70" />
                            <Bar dataKey="Somewhat Positive" stackId="a" fill="#9ECB5C" />
                            <Bar dataKey="Positive" stackId="a" fill="#69C548" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ArticleBreakdown)